var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { class: _vm.bemBlock }, [
    _vm.colorName
      ? _c(
          "p",
          { class: [_vm.bemElement("color"), _vm.bemElement("text-line")] },
          [
            _vm._v(
              "\n    " +
                _vm._s(_vm.$msg("label.color", "product") + ": ") +
                "\n    "
            ),
            _c("span", { class: _vm.bemElement("color-name") }, [
              _vm._v(_vm._s(_vm.colorName))
            ])
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.product.bylModelInfo
      ? _c(
          "p",
          { class: [_vm.bemElement("model"), _vm.bemElement("text-line")] },
          [
            _vm._v(
              "\n    " +
                _vm._s(
                  _vm.$msg("label.model", "product") +
                    ": " +
                    _vm.product.bylModelInfo
                ) +
                "\n  "
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    !_vm.product.bylModelInfo && _vm.product.bylSpecialRelevantInfo
      ? _c(
          "p",
          {
            class: [
              _vm.bemElement("special-relevant-info"),
              _vm.bemElement("text-line")
            ]
          },
          [
            _vm._v(
              "\n    " + _vm._s(_vm.product.bylSpecialRelevantInfo) + "\n  "
            )
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _vm.showOnlineExclusive &&
    !_vm.isMarketWithoutSale &&
    _vm.product.bylOnlineExclusive
      ? _c(
          "p",
          {
            class: [
              _vm.bemElement("online-exclusive"),
              _vm.bemElement("text-line")
            ]
          },
          [
            _c("BaseTag", {
              attrs: {
                type: "detail",
                subtype: "secondary",
                text: _vm.$msg("tag.exclusive", "product")
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }